import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["modal", "image", "counter"]
  static values = {
    images: Array,
    currentIndex: Number
  }

  connect() {
    console.log("lightbox connected");
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  open(event) {
    event.preventDefault();
    const index = parseInt(event.currentTarget.dataset.imageIndex || 0);
    this.currentIndexValue = index;
    this.updateImage();
    this.modalTarget.style.display = "flex";
    document.body.style.overflow = "hidden"; // Prevent background scrolling
    document.addEventListener("keydown", this.handleKeydown);
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.style.display = "none";
    document.body.style.overflow = "auto";
    document.removeEventListener("keydown", this.handleKeydown);
  }

  // Close when clicking outside the image (on the background)
  closeBackground(event) {
    if (event.target === this.modalTarget) {
      this.close(event);
    }
  }

  next(event) {
    // image wrapping
    if (event) event.preventDefault();
    this.currentIndexValue = (this.currentIndexValue + 1) % this.imagesValue.length;
    this.updateImage();
  }

  previous(event) {
    // image wrapping
    if (event) event.preventDefault();
    this.currentIndexValue = (this.currentIndexValue - 1 + this.imagesValue.length) % this.imagesValue.length;
    this.updateImage();
  }

  updateImage() {
    if (this.hasImageTarget && this.imagesValue.length > 0) {
      this.imageTarget.src = this.imagesValue[this.currentIndexValue];
      if (this.hasCounterTarget) {
        this.counterTarget.textContent = `${this.currentIndexValue + 1} / ${this.imagesValue.length}`;
      }
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    } else if (event.key === "ArrowRight") {
      this.next();
    } else if (event.key === "ArrowLeft") {
      this.previous();
    }
  }
}
